<template>
  <div>
    <l-map
      :zoom="zoom"
      :max-zoom="maxZoom"
      :center="currentMarker.coordinates"
      ref="map"
      @update:zoom="zoomUpdated"
      @update:center="centerUpdated"
      :options="{ scrollWheelZoom: false }"
      @ready="initializeFullscreen"
      style="z-index: 0;  height: 437px; "
    >
      <l-tile-layer :url="url" :attribution="attribution" />

      <l-control-layers position="topright"></l-control-layers>
      <l-tile-layer
        v-for="tileProvider in tileProviders"
        :key="tileProvider.name"
        :name="tileProvider.name"
        :visible="tileProvider.visible"
        :url="tileProvider.url"
        :attribution="tileProvider.attribution"
        layer-type="base"
      />

      <l-marker
        v-for="marker in computedMarkers"
        :key="marker.id"
        :lat-lng="marker.coordinates"
      >
        <l-tooltip class="rounded-lg">
          <div class="font-weight-bold">
            {{ lookupFPotensi(marker.id).kode2 }}
          </div>
          <div>
            {{
              lookupFSubArea(lookupFPotensi(marker.id).fsubAreaBean)
                .description
            }},
            {{
              lookupFArea(
                lookupFSubArea(lookupFPotensi(marker.id).fsubAreaBean).fareaBean
              ).description
            }}
          </div>
        </l-tooltip>

        <l-icon
          :icon-size="marker.iconSize"
          :icon-anchor="marker.iconAnchor"
          :icon-url="marker.iconUrl"
        />

        <l-popup onchange="innerClick">
          <v-flex class="d-flex caption font-weight-bold">
            <v-icon x-small class="mr-1">mdi-tag</v-icon>
            {{
              lookupFSectorType(lookupFPotensi(marker.id).fsectorTypeBean)
                .description
            }}
          </v-flex>
          <v-flex>
            <v-img
              :src="lookupImageUrl(lookupFPotensi(marker.id))"
              :lazy-src="lookupImageUrlLazy(lookupFPotensi(marker.id))"
              max-width="400"
              height="200"
              contain
            >
            </v-img>
          </v-flex>
          <v-flex class="d-flex mt-2 font-weight-bold">
            {{ lookupFPotensi(marker.id).kode2 }}
          </v-flex>
          <v-flex
            class="mt-1"
            v-if="lookupFPotensi(marker.id).district !== undefined"
          >
            <div class="caption">
              {{
                lookupFSubArea(lookupFPotensi(marker.id).fsubAreaBean)
                  .description
              }}
              ,
              <router-link
                v-if="false"
                :to="`/public-profil-daerah-detil/${
                  lookupFSubArea(lookupFPotensi(marker.id).fsubAreaBean)
                    .fareaBean
                }`"
                style="text-decoration: none"
              >
                <v-btn
                  color="blue"
                  dark
                  x-small
                  class="rounded-lg text-decoration-underline"
                  plain
                >
                  {{
                    lookupFArea(
                      lookupFSubArea(lookupFPotensi(marker.id).fsubAreaBean)
                        .fareaBean
                    ).description
                  }}
                </v-btn>
              </router-link>
              {{
                lookupFArea(
                  lookupFSubArea(lookupFPotensi(marker.id).fsubAreaBean)
                    .fareaBean
                ).description
              }}
            </div>

            <div class="d-flex align-baseline">
              <span v-if="lookupFPotensi(marker.id).remarkBool2">
                <v-icon x-small color="orange">mdi-map</v-icon>
                <span class="caption ml-1">{{ $t("terpetakan") }}</span>
              </span>
            </div>
          </v-flex>

          <v-flex class="mt-2 d-flex">
            <router-link
              style="text-decoration: none"
              :to="`public-potensi-detail/` + linkNeated(marker.id.toString())"
            >
              <v-btn color="blue lighten-2" dark x-small>
                <div class="caption align-baseline">
                  <v-icon x-small>mdi-tag</v-icon>
                  {{ $t("lihatDetail") }}
                </div>
              </v-btn>
            </router-link>

            <v-spacer></v-spacer>
            <v-btn
              @click="openGoogleMap(lookupFPotensi(marker.id))"
              x-small
              plain
            >
              <v-icon small color="orange">mdi-map-marker</v-icon>
              Google
            </v-btn>
          </v-flex>
        </l-popup>

      </l-marker>

      <l-control>
        <div class="text-center">
          <v-menu
            v-model="showLayers1"
            :close-on-content-click="false"
            :nudge-width="300"
            offset-x
            max-height="600"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="indigo"
                dark
                v-bind="attrs"
                v-on="on"
                class="rounded-lg"
                icon
                large
                outlined
                elevation="10"
              >
                <v-icon>mdi-layers</v-icon>
              </v-btn>
            </template>

            <v-card width="500px" elevation="16" class="rounded-lg">
              <v-list>
                <v-list-item class="no-gutters" dense>
                  <v-list-item-action>
                    <v-btn icon @click="showLayers1 = !showLayers1">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>

              <v-divider></v-divider>
              <v-card-text>
                <v-row class="ml-4" no-gutters>
                  <v-col
                    cols="12"
                    md="6"
                    sm="6"
                    xs="12"
                    v-for="(item, index) in computedItemsSpaMain"
                    :key="index"
                  >
                    <v-checkbox
                      v-model="item.selected"
                      input-value="true"
                      dense
                      hide-details
                      :label="item.description.trim()"
                      class="caption"
                      @change="valueChangedSpaMainGeoJson(item)"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-menu>
        </div>
      </l-control>

      <l-geo-json
        v-for="(item, index) in computedItemsSpaMainGeojson"
        :key="index"
        :geojson="item.data"
        :options="options"
        :options-style="styleFunction"
      >
      </l-geo-json>

      <l-control>
        <div class="text-center">
          <v-menu
            v-model="showLayers2"
            :close-on-content-click="false"
            :nudge-width="300"
            offset-x
            max-height="600"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                dark
                v-bind="attrs"
                v-on="on"
                class="rounded-lg"
                icon
                large
                outlined
                elevation="10"
              >
                <v-icon>mdi-layers</v-icon>
              </v-btn>
            </template>

            <v-card width="500px" elevation="16" class="rounded-lg">
              <v-list>
                <v-list-item class="no-gutters" dense>
                  <v-list-item-content>
                    <v-list-item-title
                      >{{ $t("infrastruktur") }} &
                      {{ $t("sektor") }}</v-list-item-title
                    >
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon @click="showLayers2 = !showLayers2">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>

              <v-divider></v-divider>
              <v-card-text>
                <v-row class="ml-4" no-gutters>
                  <v-col
                    cols="12"
                    md="6"
                    sm="6"
                    xs="12"
                    v-for="(item, index) in itemsFInfrastructureType.filter((x) => x.statusActive)"
                    :key="index"
                  >
                    <v-checkbox
                      v-if="lang === 'id'"
                      v-model="item.selected"
                      input-value="true"
                      dense
                      hide-details
                      :label="item.description.trim()"
                      class="caption"
                      @change="valueChangedInfraTypeMarker(item)"
                    ></v-checkbox>
                    <v-checkbox
                      v-if="lang === 'en'"
                      v-model="item.selected"
                      input-value="true"
                      dense
                      hide-details
                      :label="item.descriptionEn.trim()"
                      class="caption"
                      @change="valueChangedInfraTypeMarker(item)"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-menu>
        </div>
      </l-control>

      <l-marker
        v-for="marker in computedInfraMarkers"
        :key="marker.id"
        :lat-lng="marker.coordinates"
      >
        <l-tooltip class="rounded-lg" v-if="true">
          <div>
            <div class="font-weight-bold">
              {{ marker.description }}
            </div>
            <div v-if="marker.fsubArea">
              {{ marker.fsubArea }}
              -
              {{ marker.farea }}
            </div>
          </div>
        </l-tooltip>

        <l-icon :icon-size="marker.iconSize" :icon-url="marker.iconUrl" v-if="true" />

        <l-popup v-if="true">
          <div>
            <div class="d-flex mt-1 font-weight-bold">
              {{ marker.description}}
            </div>
            <div v-if="marker.fsubArea">
              {{ marker.fsubArea }}
              -
              {{ marker.farea }}
            </div>
            <v-spacer></v-spacer>
            <div class="mt-2">
              <v-btn
                  @click="openGoogleMapCoords(marker)"
                  x-small
                  plain
              >
                <v-icon small color="orange">mdi-map-marker</v-icon>
                Google
              </v-btn>
            </div>
          </div>


        </l-popup>

      </l-marker>

      <l-control>

        <div class="text-center" v-if="true">
          <v-menu
            v-model="showLayers3"
            :close-on-content-click="false"
            :nudge-width="300"
            offset-x
            max-height="600"
            style="z-index: 100000 !important; position: relative;"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="orange"
                dark
                v-bind="attrs"
                v-on="on"
                class="rounded-lg"
                icon
                large
                outlined
                elevation="10"
              >
                <v-icon>mdi-layers</v-icon>
              </v-btn>
            </template>

            <v-card width="500px" elevation="16" class="rounded-lg" >
              <v-list>
                <v-list-item class="no-gutters" dense>
                  <v-list-item-content>
                    <v-list-item-title>Komoditi</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon @click="showLayers3 = !showLayers3" small>
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>

              <v-divider></v-divider>
              <v-card-text>
                <v-row class="ml-4" no-gutters>
                  <v-col
                    cols="12"
                    md="6"
                    sm="6"
                    xs="12"
                    v-for="(item, index) in itemsFSectorType.filter(x => x.statusActive)"
                    :key="index"
                  >
                    <v-checkbox
                      v-if="lang === 'id'"
                      v-model="item.selected"
                      input-value="true"
                      dense
                      hide-details
                      :label="item.description.trim()"
                      class="caption"
                      @change="valueChangedKomoditiTypeMarker(item)"
                    ></v-checkbox>
                    <v-checkbox
                      v-if="lang === 'en'"
                      v-model="item.selected"
                      input-value="true"
                      dense
                      hide-details
                      :label="item.descriptionEn.trim()"
                      class="caption"
                      @change="valueChangedKomoditiTypeMarker(item)"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-menu>
        </div>
      </l-control>

      <l-marker
        v-for="marker in computedKomoditiMarkers"
        :key="marker.id"
        :lat-lng="marker.coordinates"
      >
        <l-tooltip class="rounded-lg" v-if="true">
          <div>
            <div class="font-weight-bold">
              {{ marker.description }}
            </div>
            <div v-if="marker.fsubArea">
              {{ marker.fsubArea }}
              -
              {{ marker.farea }}
            </div>
          </div>
        </l-tooltip>

        <l-icon :icon-size="marker.iconSize" :icon-url="marker.iconUrl" />

        <l-popup v-if="true">
          <div>
            <div class="d-flex mt-1 font-weight-bold">
              {{ marker.description}}
            </div>
            <div v-if="marker.fsubArea">
              {{ marker.fsubArea }}
              -
              {{ marker.farea }}
            </div>
            <v-spacer></v-spacer>
            <div class="mt-2">
              <v-btn
                  @click="openGoogleMapCoords(marker)"
                  x-small
                  plain
              >
                <v-icon small color="orange">mdi-map-marker</v-icon>
                Google
              </v-btn>
            </div>
          </div>


        </l-popup>

      </l-marker>

<!--      <l-control-polyline-measure-->
<!--        :options="{ showUnitControl: true }"-->
<!--        position="topleft"-->
<!--      />-->

      <l-control position="topright" v-if="isFullScreen">
        <div v-if="showLayers1">
          <v-card width="500px" elevation="16" class="rounded-lg">
            <v-list>
              <v-list-item class="no-gutters" dense>
                <v-list-item-action>
                  <v-btn icon @click="showLayers1 = !showLayers1">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>

            <v-divider></v-divider>
            <v-card-text>
              <v-row class="ml-4" no-gutters>
                <v-col
                    cols="12"
                    md="6"
                    sm="6"
                    xs="12"
                    v-for="(item, index) in computedItemsSpaMain"
                    :key="index"
                >
                  <v-checkbox
                      v-model="item.selected"
                      input-value="true"
                      dense
                      hide-details
                      :label="item.description.trim()"
                      class="caption"
                      @change="valueChangedSpaMainGeoJson(item)"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </div>
      </l-control>

      <l-control  position="topright"  v-if="isFullScreen">
        <div v-if="showLayers2">
          <v-card width="500px" elevation="16" class="rounded-lg">
            <v-list>
              <v-list-item class="no-gutters" dense>
                <v-list-item-content>
                  <v-list-item-title
                  >{{ $t("infrastruktur") }} &
                    {{ $t("sektor") }}</v-list-item-title
                  >
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon @click="showLayers2 = !showLayers2">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>

            <v-divider></v-divider>
            <v-card-text>
              <v-row class="ml-4" no-gutters>
                <v-col
                    cols="12"
                    md="6"
                    sm="6"
                    xs="12"
                    v-for="(item, index) in itemsFInfrastructureType.filter(
                      (x) => x.statusActive
                    )"
                    :key="index"
                >
                  <v-checkbox
                      v-if="lang === 'id'"
                      v-model="item.selected"
                      input-value="true"
                      dense
                      hide-details
                      :label="item.description.trim()"
                      class="caption"
                      @change="valueChangedInfraTypeMarker(item)"
                  ></v-checkbox>
                  <v-checkbox
                      v-if="lang === 'en'"
                      v-model="item.selected"
                      input-value="true"
                      dense
                      hide-details
                      :label="item.descriptionEn.trim()"
                      class="caption"
                      @change="valueChangedInfraTypeMarker(item)"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </div>
      </l-control>

      <l-control position="topright" v-if="isFullScreen">
        <div v-if="showLayers3">
          <v-card width="500px" elevation="16" class="rounded-lg" >
            <v-list>
              <v-list-item class="no-gutters" dense>
                <v-list-item-content>
                  <v-list-item-title>Komoditi</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon @click="showLayers3 = !showLayers3" small>
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>

            <v-divider></v-divider>
            <v-card-text>
              <v-row class="ml-4" no-gutters>
                <v-col
                    cols="12"
                    md="6"
                    sm="6"
                    xs="12"
                    v-for="(item, index) in itemsFSectorType.filter(x => x.statusActive)"
                    :key="index"
                >
                  <v-checkbox
                      v-if="lang === 'id'"
                      v-model="item.selected"
                      input-value="true"
                      dense
                      hide-details
                      :label="item.description.trim()"
                      class="caption"
                      @change="valueChangedKomoditiTypeMarker(item)"
                  ></v-checkbox>
                  <v-checkbox
                      v-if="lang === 'en'"
                      v-model="item.selected"
                      input-value="true"
                      dense
                      hide-details
                      :label="item.descriptionEn.trim()"
                      class="caption"
                      @change="valueChangedKomoditiTypeMarker(item)"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </div>
      </l-control>


    </l-map>
  </div>
</template>

<script>
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon,
  LPopup,
  LControlLayers,
  LTooltip,
  LControl,
  LGeoJson,
} from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import 'leaflet-fullscreen';
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css';
import L from 'leaflet';


// import LControlPolylineMeasure from "vue2-leaflet-polyline-measure";

import FileService from "@/services/apiservices/file-service";
import FInfrastructureService from "@/services/apiservices/f-infrastructure-service";
import FKomoditiService from "@/services/apiservices/f-komoditi-service";

import { Icon } from "leaflet";
delete Icon.Default.prototype.Default;
// Icon.Default.mergeOptions({
//   iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
//   iconUrl: require('leaflet/dist/images/marker-icon.png'),
//   shadowUrl: require('leaflet/dist/images/marker-shadow.png')
// });
Icon.Default.mergeOptions({
  iconRetinaUrl: require("@/assets/images/my-marker.png"),
  iconUrl: require("@/assets/images/my-marker.png"),
  shadowUrl: require("@/assets/images/my-marker.png"),
});

export default {
  name: "PotensiMainMap",
  components: {
    LMap,
    LTileLayer,
    LControl,
    LControlLayers,
    LMarker,
    LIcon,
    LPopup,
    LTooltip,
    LGeoJson,
    // LControlPolylineMeasure,
  },
  props: {
    itemsFDayaDukung: Array,
    itemsFDayaDukungType: Array,
    itemsFSectorType: Array,
    itemsFSubArea: Array,
    itemsFArea: Array,
    itemsFPotensi: Array,
    itemsFInfrastructureType: Array,
    itemsFKomoditiType: Array,
  },
  watch: {
    lang: {
      handler: function (val, oldVal) {
        if (val !== oldVal) {
          // this.fetchFSectorType()
        }
      },
    },
    itemsFDayaDukung: {
      handler: function (val, oldVal) {
        if (val !== oldVal) {
          if (
            !this.firstLoadGeoJsonSelected &&
            this.itemsFDayaDukung.length > 0
          ) {
            this.computedItemsSpaMain.forEach((item) => {
              if (item.selected) {
                this.valueChangedSpaMainGeoJson(item);
              }
            });
            this.firstLoadGeoJsonSelected = true;
          }
        }
      },
    },
  },
  data() {
    return {
      isFullScreen: false,

      enableTooltip: true,
      zoom: 12,
      maxZoom: 18,
      currentMarker: {
        id: 0,
        coordinates: [-7.865971542414, 112.51330492128388],
      },

      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',

      tileProviders: [
        {
          name: "OpenStreetMap",
          visible: true,
          attribution:
            '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
          url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        },
        {
          name: "OpenTopoMap",
          visible: false,
          url: "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
          attribution:
            'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
        },
        {
          name: "Satelite",
          visible: false,
          url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
          attribution:
            '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        },
      ],

      showLayers1: false,
      showLayers2: false,
      showLayers3: false,

      mapFullScreen: false,

      geojson: null,
      itemSpaMainGeojson: [],

      finfratructures: [],
      finfratructureTypesSelected: [],
      itemsFInfrastructure: [],

      fkomodities: [],
      fsectorTypesSelected: [],
      fkomoditiTypesSelected: [],
      colorMap: {},
      firstLoadGeoJsonSelected: false,
    };
  },
  computed: {
    computedMarkers() {
      let markers = [];

      this.itemsFPotensi.forEach((item) => {
        if (item.lat !== 0 && item.lon !== 0) {
          const sectorType = this.lookupFSectorType(item.fsectorTypeBean);
          const sectorTypeMarker1 = sectorType.markerImage1;

          let marker = this.currentMarker;
          marker = {
            id: item.id,
            coordinates: [item.lat, item.lon],
            iconUrl: this.lookupImageMarkerUrl(sectorTypeMarker1),
            iconSize: [45, 65],
            // iconAnchor: [16, 37]
          };
          markers.push(marker);
        }
      });

      return markers;
    },
    computedItemsSpaMain() {
      return this.itemsFDayaDukung.filter(
        (x) =>
          x.showToMap &&
          x.description !== "" &&
          x.fdivisionBean > 0 &&
          x.fdayaDukungTypeBean > 0 &&
          x.statusActive === true
      );
    },

    computedItemsSpaMainGeojson() {
      return this.itemSpaMainGeojson;
    },

    options() {
      return {
        onEachFeature: this.onEachFeatureFunction,
      };
    },

    onEachFeatureFunction() {
      if (!this.enableTooltip) {
        return () => {};
      }
      return (feature, layer) => {
        layer.bindTooltip(
          "<div>" + this.jsonToHtmlTable(feature.properties) + "</div>",
          { permanent: false, sticky: true }
        );
      };
    },

    computedInfraMarkers() {
      let markers = [];

      if (this.finfratructures !== undefined) {
        this.finfratructures.forEach((item) => {
          if (item.lat !== 0 && item.lon !== 0) {
            const infrastructureType = this.lookupFInfrastructureType(item.finfrastructureTypeBean);
            const infrastructureTypeMarker1 = infrastructureType.markerImage1;

            let marker = {
              id: item.id,
              coordinates: [item.lat, item.lon],
              iconUrl: this.lookupImageMarkerUrl(infrastructureTypeMarker1),
              // iconSize: [23, 35],
              iconSize: [28, 35],

              description: item.description,
              fsubArea: this.lookupFSubArea(item.fsubAreaBean).description,
              farea: this.lookupFArea(this.lookupFSubArea(item.fsubAreaBean).fareaBean).description
            };

            markers.push(marker);
          }
        });
      }

      return markers;
    },

    computedKomoditiMarkers() {
      let markers = [];

      if (this.fkomodities !== undefined) {
        this.fkomodities.forEach((item) => {
          // console.log(JSON.stringify(item.lat))

          if (item.lat !== 0 && item.lon !== 0) {
            const komoditiType = this.lookupFKomoditiType(
              item.fkomoditiTypeBean
            );
            const komoditiTypeMarker1 = komoditiType.markerImage1;

            let marker = {
              id: item.id,
              coordinates: [item.lat, item.lon],
              iconUrl: this.lookupImageMarkerUrl(komoditiTypeMarker1),
              // iconSize: [23, 35],
              iconSize: [28, 28],

              description: item.description,
              fsubArea: this.lookupFSubArea(item.fsubAreaBean).description,
              farea: this.lookupFArea(this.lookupFSubArea(item.fsubAreaBean).fareaBean).description

            };
            markers.push(marker);
          }
        });
      }

      return markers;
    },

    lang: {
      get() {
        return this.$store.state.langModule.lang;
      },
      set(val) {
        this.$store.dispatch("langModule/setLang", val);
      },
    },
  },
  methods: {
    initializeFullscreen() {
      const map = this.$refs.map.mapObject;
      L.control.fullscreen().addTo(map);
    },
    handleFullscreenChange() {
      this.isFullScreen = !!document.fullscreenElement;
      console.log(`fullscreenchange detected: ${this.isFullScreen}`);
    },

    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
    centerUpdated(center) {
      this.center = center;
    },

    linkNeated(link) {
      return link.replace(/\s+/g, "-").toLocaleLowerCase();
    },
    lookupImageMarkerUrl(markerImage) {
      if (markerImage === undefined || markerImage === "") {
        return "/assets/images/my-marker.png";
      } else {
        return FileService.image_url_ori(markerImage);
      }
    },

    getRandomColor() {
      const letters = "0123456789ABCDEF";
      let color = "#";
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    styleFunction(feature) {
      let tebalGarisTepi = 1.2;
      try {
        if ( feature.geometry.type ==="MultiLineString"){
          tebalGarisTepi  = 4.5;
        }
      }catch (e) {
        console.log(e)
      }

      let fillOpacity = 0.35;
      try{
        if (feature.properties.NAMOBJ === "Kawasan Peruntukan Industri" || feature.properties.NAMOBJ === 'KPI'){
          fillOpacity = 0.8;
          tebalGarisTepi  = 3;
        }
      }catch (e) {
        console.log(e)
      }

      const identifier =
        feature.properties.Kabupaten +
        feature.properties.kabupaten +
        feature.properties.KABUPATEN +
        feature.properties.Kecamatan +
        feature.properties.kecamatan +
        feature.properties.KECAMATAN +
        feature.properties.Kec +
        feature.properties.KEC +
        feature.properties.Kab +
        feature.properties.KAB +
        feature.properties.Desa +
        feature.properties.desa +
        feature.properties.DESA +
        feature.properties.pola_ruang +
        feature.properties.POLA_RUANG +
        feature.properties.keterangan +
        feature.properties.KETERANGAN +
        feature.properties.Penggunaan +
        feature.properties.penggunaan +
        feature.properties.PENGGUNAAN +
        feature.properties.NAMOBJ +
        feature.properties.OBJECTID; // Gabungan sebagai kunci unik
      if (!this.colorMap[identifier]) {
        this.colorMap[identifier] = this.getRandomColor(); // Menyimpan warna baru jika belum ada
      }

      return {
        color: this.colorMap[identifier],
        weight: tebalGarisTepi,
        opacity: 0.8,
        fillColor: this.colorMap[identifier],
        fillOpacity: fillOpacity,
      };
    },

    lookupFPotensi(fpotensiBean) {
      const items = this.itemsFPotensi.filter((x) => x.id === fpotensiBean);
      if (items.length > 0) {
        return items[0];
      } else {
        return Object;
      }
    },
    lookupFSectorType(fsectorTypeBean) {
      const str = this.itemsFSectorType.filter((x) => x.id === fsectorTypeBean);
      if (str.length > 0) {
        return str[0];
      } else {
        return "-";
      }
    },
    lookupFInfrastructureType(finfrastructureTypeBean) {
      const str = this.itemsFInfrastructureType.filter(
        (x) => x.id === finfrastructureTypeBean
      );
      if (str.length > 0) {
        return str[0];
      } else {
        return "-";
      }
    },
    lookupFKomoditiType(fkomoditiTypeBean) {
      const str = this.itemsFKomoditiType.filter(
        (x) => x.id === fkomoditiTypeBean
      );
      if (str.length > 0) {
        return str[0];
      } else {
        return "-";
      }
    },

    lookupFSubArea(fsubAreaBean) {
      const str = this.itemsFSubArea.filter((x) => x.id === fsubAreaBean);
      if (str.length > 0) {
        return str[0];
      } else {
        return "-";
      }
    },
    lookupFArea(fareaBean) {
      const str = this.itemsFArea.filter((x) => x.id === fareaBean);
      if (str.length > 0) {
        return str[0];
      } else {
        return "-";
      }
    },

    lookupImageUrl(item) {
      if (item.avatarImage === undefined || item.avatarImage === "") {
        return "./assets/images/no_image_available.jpeg";
      } else {
        return FileService.image_url_low(item.avatarImage);
      }
    },
    lookupImageUrlLazy(item) {
      if (item.avatarImage === undefined || item.avatarImage === "") {
        return "./assets/images/no_image_available.jpeg";
      } else {
        return FileService.image_url_verylow(item.avatarImage);
      }
    },

    async valueChangedSpaMainGeoJson(value) {
      const response = await fetch(FileService.file_url(value.fileNameLow));
      if (value.selected === true) {
        const geojsonResponse = await response.json();
        this.itemSpaMainGeojson.push({
          id: value.id,
          data: geojsonResponse,
          lineColor: value.remark1,
          fillColor: value.remark2,
        });
      } else {
        const index = this.itemSpaMainGeojson.findIndex(
          (item) => item.id === value.id
        );
        this.itemSpaMainGeojson.splice(index, 1);
      }
    },
    jsonToHtmlTable(jsonValue) {
      const myObj = jsonValue;

      let text =
        "<table style='width: 300px'>\n" +
        "         <tr>\n" +
        "            <td style='width:40%'>::</td>\n" +
        "            <th></th>\n" +
        "         </tr>\n";
      for (const meta in myObj) {
        text +=
          "         <tr>\n" +
          "            <td style='color: #777777'>" +
          meta +
          "</td>\n" +
          "            <td>: &nbsp;" +
          myObj[meta] +
          "</td>\n" +
          "         </tr>\n";
      }
      text += "      </table>";

      return text;
    },

    valueChangedInfraTypeMarker(value) {
      if (value.selected === true) {
        this.finfratructureTypesSelected.push(value.id);
      } else {
        const index = this.finfratructureTypesSelected.findIndex(
          (itemId) => itemId === value.id
        );
        this.finfratructureTypesSelected.splice(index, 1);
      }

      if (this.finfratructureTypesSelected.length === 0) {
        this.finfratructures = [];
        return;
      }

      FInfrastructureService.getPostAllFInfrastructureByTypesPublicSimple(this.finfratructureTypesSelected).then(
          (response) => {
            this.finfratructures = response.data;
            // console.log(JSON.stringify(this.finfratructures))
          });
    },

    valueChangedKomoditiTypeMarker(value) {
      this.fkomoditiTypesSelected = [];

      if (value.selected === true) {
        this.fsectorTypesSelected.push(value.id);
      } else {
        const index = this.fsectorTypesSelected.findIndex(
          (itemId) => itemId === value.id
        );
        this.fsectorTypesSelected.splice(index, 1);
      }

      // console.log(JSON.stringify(this.fsectorTypesSelected))

      this.fsectorTypesSelected.forEach((sectorId) => {
        this.itemsFKomoditiType.filter((x) => x.fsectorTypeBean === sectorId && x.statusActive).forEach( komodityType  =>
            this.fkomoditiTypesSelected.push(komodityType.id)
          );
      });

      // console.log(JSON.stringify(this.fkomoditiTypesSelected))

      if (this.fkomoditiTypesSelected.length === 0) {
        this.fkomodities = [];
        return;
      }

      FKomoditiService.getPostAllFKomoditiByTypesPublicSimple(this.fkomoditiTypesSelected).then(
          (response) => {
              this.fkomodities = [];

              response.data.forEach((item) => {
                // let randomInt = this.getRandomInt(-888, 888) * 0.00001;
                // console.log(JSON.stringify(this.lookupFSubArea(item.fsubAreaBean)))
                item.lat = item.lat !== 0 ? item.lat : this.lookupFSubArea(item.fsubAreaBean).lat;
                item.lon = item.lon !== 0 ? item.lon : this.lookupFSubArea(item.fsubAreaBean).lon;

                if (
                  item.lat !== 0 &&
                  item.lon !== 0 &&
                  !isNaN(item.lat) &&
                  !isNaN(item.lon)
                ) {
                  this.fkomodities.push(item);
                }
              });
            });
    },

    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },

    openGoogleMapCoords(marker) {
      const urlSuffix = `${marker.coordinates[0]},${marker.coordinates[1]}&z=15`;
      window.open("https://maps.google.com/maps?q=" + urlSuffix, "_blank");
    },
    openGoogleMap(item) {
      const urlSuffix = `${item.lat},${item.lon}&z=15`;
      window.open("https://maps.google.com/maps?q=" + urlSuffix, "_blank");
    },

  },

  mounted() {
    this.currentMarker = this.$store.state.potensi.centerMap
    // this.currentMarker =  {id: 0, coordinates: [-7.865971542414, 112.51330492128388]}

    document.addEventListener('fullscreenchange', this.handleFullscreenChange);

  },
  beforeDestroy() {
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
  }
};
</script>

<style scoped>

</style>
